import {
  primaryGrayBg,
  PrimaryTextColor,
  getRelativeFontSize,
  regularFont,
  boldFont,
  primaryBlueColor,
} from "../../utils/styles";

const SettingsStyles = {
  SettingsWrapper: {
    padding: "20px 20px",
  },

  card: {
    background: primaryGrayBg,
    Height: "154px",
    maxWidth: "280px",
    padding: "32px 36px 26px 32px",
    display: "flex",
    borderRadius: "10px",
    cursor: "pointer",
  },
  cardHeader: {
    marginRight: "16px",
  },
  cardtext: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    ...regularFont,
    marginBottom: 0.5,
    height: "36px",
  },
  cardHeadinig: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    marginBottom: 0.5,
  },

  customStyle: {
    ...regularFont,
    color: primaryBlueColor,
    fontSize: getRelativeFontSize(),
    cursor: "pointer",
  },
  buttonWrapper: {
    display: "flex",
    gap: "20px",
  },
};

export default SettingsStyles;
